import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorDoesNotHaveFiscalRegime extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor does not have fiscal regimen to enable automatic invoicing', options);
    }
}
export default InvestorDoesNotHaveFiscalRegime;
